import {
    exportApi,
} from './http.js'
export function exportShmedicineApi() { //获取微信用户信息
    return exportApi({
        url: 'admin/sh_medicine/export',
        method: 'get',
        responseType: 'blob',
        headers: {
            "Content-Type": 'application/json;charset=UTF-8'
        }
    })
}
export function exportMedicineListApi(provider_id) { //获取微信用户信息
    return exportApi({
        url: 'admin/medicine/export?provider_id=' + provider_id,
        method: 'get',
        responseType: 'blob',
        headers: {
            "Content-Type": 'application/json;charset=UTF-8'
        }
    })
}